import { useTranslation } from 'react-i18next';

import {
  AccordionTabHeaderTemplate,
  AccordionTabHeaderTemplateProps,
} from '@features/campaigns/shared/components/AccordionTabHeaderTemplate/AccordionTabHeaderTemplate.tsx';
import { i18nNameSpace } from '@shared/consts/i18n.ts';
import { useFakeProgressGenerator } from '@shared/hooks/useFakeProgressGenerator.ts';

import styles from './AISummaryTabHeader.module.scss';

interface AISummaryTabHeaderProps extends AccordionTabHeaderTemplateProps {
  completed: boolean;
  isLoading: boolean;
}

export function AISummaryTabHeader({ iconVariant, accordionTitle, completed, isLoading }: AISummaryTabHeaderProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);

  const { formattedValue } = useFakeProgressGenerator({
    duration: 15,
    completed,
  });

  return (
    <AccordionTabHeaderTemplate iconVariant={iconVariant} accordionTitle={accordionTitle}>
      <p className={styles.accordionSubtitle}>
        {isLoading ? (
          <>
            <span>{formattedValue}% </span>
            {t('page.campaignDetails.performanceTab.summaryHeader.generated')}
          </>
        ) : (
          <>{t('page.campaignDetails.performanceTab.summaryHeader.summaryGenerated')}</>
        )}
      </p>
    </AccordionTabHeaderTemplate>
  );
}
